import { SellerOrderStatus } from '@shopify-multiseller/graphql/partner/types';
import { Badge } from '../primitives';

export const SellerOrderStatusBadge: React.FC<{
    status: SellerOrderStatus;
    size?: 'small' | 'medium';
    /** Leading dot — for the status column of a list, where colour is scanned. */
    dot?: boolean;
}> = ({ status, size, dot }) => {
    const className = size === 'medium' ? 'px-2.5 py-1' : undefined;
    switch (status) {
        case SellerOrderStatus.WaitingThirdParty:
            return <Badge variant="success" dot={dot} className={className}>Accepted</Badge>;
        case SellerOrderStatus.Fulfilled:
            return <Badge variant="success" dot={dot} className={className}>Fulfilled</Badge>;
        case SellerOrderStatus.PendingFulfillment:
            return <Badge variant="warning" dot={dot} className={className}>To fulfil</Badge>;
        case SellerOrderStatus.RejectedThirdParty:
        case SellerOrderStatus.Rejected:
            return <Badge variant="destructive" dot={dot} className={className}>Rejected</Badge>;
        case SellerOrderStatus.Pending:
            // Two labels for one status, which is what the design draws.
            //
            // On an order's own header there is room to name what is awaited
            // and whose move it is — "Awaiting your acceptance" — and that is
            // the screen with a countdown on it, so the badge should say what
            // the countdown is for. In a dashboard row or a list column the
            // same phrase would be longer than the row, so those keep
            // "Pending", as the design does.
            //
            // A first version changed both and cost the dashboard four matches:
            // one component, but not one context.
            return (
                <Badge variant="warning" dot={dot} className={className}>
                    {size === 'medium' ? 'Awaiting your acceptance' : 'Pending'}
                </Badge>
            );
        case SellerOrderStatus.AcceptTimeout:
            return <Badge variant="destructive" dot={dot} className={className}>Accept timeout</Badge>;
        case SellerOrderStatus.FulfillmentTimeout:
            return <Badge variant="destructive" dot={dot} className={className}>Fulfilment timeout</Badge>;
        // A cancelled order previously rendered no badge at all, so the one
        // status a seller most needs to see was the one the page didn't state.
        case SellerOrderStatus.Cancelled:
            return <Badge variant="neutral" dot={dot} className={className}>Cancelled</Badge>;
        default:
            return null;
    }
};
